import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-feedback-id-renderer',
    templateUrl: './feedback-id-renderer.component.html',
    styleUrls: ['./feedback-id-renderer.component.css'],
    standalone: false
})
export class FeedbackIdRendererComponent implements ICellRendererAngularComp {
  feedbackId = '';
  isUnread = false;
  private params: any;

  agInit(params: any): void {
    this.params = params;
    this.feedbackId = params.value ?? '';
    this.isUnread = params.data?.isRead === 'N';
  }

  refresh(params: any): boolean {
    this.params = params;
    this.feedbackId = params.value ?? '';
    this.isUnread = params.data?.isRead === 'N';
    return true;
  }

  onClickFeedbackId(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.params?.context?.componentParent?.openFeedbackDetail(this.params.data);
  }
}
